export function createLogsDataLoadedHandler($scope, chartModel) {
    return () => {
        if (chartModel?.sf_id) {
            $scope.$root.$broadcast('logs-chart-data-loaded', chartModel.sf_id);
            $scope.$applyAsync();
        }
    };
}
